// @flow
// import { Button } from 'antd'
import { FormBuilderContext } from 'pages/Contexts/FormBuilderContext'
// import BuilderDescriptionQuestionModalEditor from 'pages/FormBuilder/Components/BuilderDescriptionQuestionModalEditor'
import * as React from 'react'

// import useBuilderQuestion from 'utils/FormBuilder/hooks/useBuilderQuestion'
// import { ZentakeContext } from 'utils/ZentakeContext'
// import Modal from '@/ui/Modal'
import BuilderDescriptionQuestionModalQuill from './BuilderDescriptionQuestionModalQuill'

function BuilderDescriptionQuestionModal(): React.Node {
  // const { teamDetails } = React.useContext(ZentakeContext)
  // const editorRef = React.useRef < any > (null)

  // const { selectedItem, setQuestion, setIsEditingDescription } =
  React.useContext(FormBuilderContext)

  // const question = useBuilderQuestion(selectedItem.id)

  // const [value, setValue] = React.useState(question?.text ?? '')
  // const [isSaving, setIsSaving] = React.useState(false)

  // const onCancel = React.useCallback(() => {
  //   setIsEditingDescription(false)
  // }, [setIsEditingDescription])

  // function onSaveDescriptionQuestionText() {
  //   const value: string = editorRef.current?.getValue()

  //   setValue(value)
  //   setIsSaving(true)

  //   try {
  //     setQuestion(selectedItem.id, {
  //       ...question,
  //       text: value,
  //     })
  //     setIsEditingDescription(false)
  //   } catch (error) {
  //   } finally {
  //     setIsSaving(false)
  //   }
  // }

  return <BuilderDescriptionQuestionModalQuill />

  // return (
  //   <Modal
  //     open
  //     footer={
  //       <div className="my-3 flex justify-end gap-2">
  //         <Button onClick={onCancel}>Cancel</Button>
  //         <Button
  //           disabled={isSaving}
  //           loading={isSaving}
  //           onClick={onSaveDescriptionQuestionText}
  //           type="primary"
  //         >
  //           Save
  //         </Button>
  //       </div>
  //     }
  //     onCancel={onCancel}
  //     onClose={onCancel}
  //     title="Description"
  //   >
  //     <BuilderDescriptionQuestionModalEditor ref={editorRef} value={value} />
  //   </Modal>
  // )
}

export default BuilderDescriptionQuestionModal
